var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { CODE_TEMPLATE, COMMENTS, IMMEDIATE_CODE_TEMPLATE } from './constants';
import { jsonToSchema } from './util';
var getFnParams = function (_a) {
    var data = _a.data, outputs = _a.outputs;
    var params = __spreadArray(['context', 'inputValue'], outputs.get().map(function (_a) {
        var id = _a.id;
        return id;
    }), true);
    if (data.runImmediate) {
        params.splice(1, 1);
    }
    return params;
};
var getExtralib = function (_a) {
    var outputs = _a.outputs;
    return __spreadArray(__spreadArray([], outputs.get().map(function (_a) {
        var id = _a.id, title = _a.title;
        return "/** \n* ".concat(title, " \n*/ \ndeclare function ").concat(id, "(val: any): void");
    }), true), [
        "declare var inputValue: any;",
    ], false).join(';\n');
};
// editors inject run method
var forceRender = { run: function () { } };
export default {
    '@init': function (_a) {
        var data = _a.data, setAutoRun = _a.setAutoRun, isAutoRun = _a.isAutoRun, output = _a.output;
        var autoRun = isAutoRun ? isAutoRun() : false;
        if (autoRun || data.runImmediate) {
            setAutoRun(true);
            data.runImmediate = true;
            output.get('output0').setSchema({ type: 'number' });
        }
        data.fns = data.fns || (data.runImmediate ? IMMEDIATE_CODE_TEMPLATE : CODE_TEMPLATE);
        // data.fnBody = data.fnBody || encodeURIComponent(CODE_TEMPLATE);
        // data.fnParams = data.fnParams || getFnParams({ data, outputs: output });
    },
    '@pinRemoved': function (_a) {
        var data = _a.data, outputs = _a.outputs;
        // data.fnParams = getFnParams({ data, outputs });
    },
    '@inputUpdated': function (_a, fromPin) {
        var data = _a.data;
        data.inputSchema = fromPin.schema;
    },
    '@inputConnected': function (_a, fromPin) {
        var data = _a.data, output = _a.output;
        data.inputSchema = fromPin.schema;
        if (data.fns === CODE_TEMPLATE) {
            output.get('output0').setSchema({ type: 'unknown' });
        }
    },
    '@inputDisConnected': function (_a) {
        var data = _a.data;
        data.inputSchema = { type: 'any' };
    },
    ':root': [
        {
            title: '添加输出项',
            type: 'Button',
            value: {
                set: function (_a) {
                    var output = _a.output;
                    var idx = getOutputOrder({ output: output });
                    var hostId = "output".concat(idx);
                    var title = "\u8F93\u51FA\u9879".concat(idx);
                    output.add({
                        id: hostId,
                        title: title,
                        schema: {
                            type: 'unknown'
                        },
                        editable: true,
                        deletable: true
                    });
                    // data.fnParams = getFnParams({ data, outputs: output });
                    // forceRender.run();
                }
            }
        },
        {
            type: 'code',
            options: function (_a) {
                var data = _a.data, output = _a.output;
                var option = {
                    babel: true,
                    comments: COMMENTS,
                    theme: 'light',
                    minimap: {
                        enabled: false
                    },
                    lineNumbers: 'on',
                    // forceRender,
                    eslint: {
                        parserOptions: {
                            ecmaVersion: '2020',
                            sourceType: 'module'
                        }
                    },
                    autoSave: false,
                    onBlur: function () {
                        updateOutputSchema(output, data.fns);
                    },
                    schema: data.inputSchema
                };
                // Object.defineProperty(option, 'fnParams', {
                //   get() {
                //     return getFnParams({data, outputs });
                //   },
                //   configurable: true
                // });
                // Object.defineProperty(option, 'extraLib', {
                //   get() {
                //     return getExtralib({ outputs });
                //   },
                //   configurable: true
                // });
                return option;
            },
            title: '代码编辑',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.fns;
                },
                set: function (_a, fns) {
                    var data = _a.data;
                    data.fns = fns;
                }
            }
        }
    ]
};
function updateOutputSchema(output, code) {
    var outputs = {};
    output.get().forEach(function (_a) {
        var id = _a.id;
        outputs[id] = function (v) {
            try {
                var schema = jsonToSchema(v);
                output.get(id).setSchema(schema);
            }
            catch (error) {
                output.get(id).setSchema({ type: 'unknown' });
            }
        };
    });
    try {
        setTimeout(function () {
            var fn = eval(decodeURIComponent(code.code || code));
            fn({
                inputValue: void 0,
                outputs: outputs
            });
        });
    }
    catch (error) { }
}
function getOutputOrder(_a) {
    var output = _a.output;
    var ports = output.get();
    var id = ports.pop().id;
    return Number(id.slice(6)) + 1;
}
